export enum LinkTypesEnum {
    twitter = 'TWITTER',
    facebook = 'FACEBOOK',
    instagram = 'INSTAGRAM',
    youtube = 'YOUTUBE',
    linkedin = 'LINKEDIN',
    snapchat = 'SNAPCHAT',
    tiktok = 'TIKTOK',
    website = 'WEBSITE',
    bluesky = 'BLUESKY'

}

export const linkTypesToLabelStrings = {
    [LinkTypesEnum.twitter]: 'X',
    [LinkTypesEnum.facebook]: 'Facebook',
    [LinkTypesEnum.instagram]: 'Instagram',
    [LinkTypesEnum.youtube]: 'YouTube',
    [LinkTypesEnum.linkedin]: 'LinkedIn',
    [LinkTypesEnum.snapchat]: 'Snapchat',
    [LinkTypesEnum.tiktok]: 'TikTok',
    [LinkTypesEnum.website]: 'Website',
    [LinkTypesEnum.bluesky]: 'Bluesky',
};
